import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryShowcase() {
  return (
    <section id="categories" className="py-16 md:py-24 bg-background-50">
      <div className="container-custom">
        <h2 className="section-title">探索领域</h2>
        <p className="section-subtitle">
          六个维度，全方位探索你的欲望世界
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((category, i) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="group relative overflow-hidden rounded-lg h-[280px] md:h-[320px] cursor-pointer"
            >
              <div
                className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110"
                style={{ backgroundImage: `url(${category.image})` }}
                role="img"
                aria-label={category.name}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/20" />

              <div className="absolute inset-0 flex flex-col justify-end p-5 md:p-6">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/20 text-primary-400 mb-3">
                  <i className={`${category.icon} text-lg`}></i>
                </div>
                <h3 className="text-lg md:text-xl font-semibold text-foreground-100 font-heading mb-1">
                  {category.name}
                </h3>
                <p className="text-sm text-foreground-400 leading-relaxed line-clamp-2 mb-3">
                  {category.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-500">
                    {category.articleCount} 篇文章
                  </span>
                  <span className="text-xs text-primary-400 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center gap-1">
                    探索
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}